import { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import useTranslate from "../../hooks/useTranslate";
import { colorRed } from "../../constants/colors";
import DraggablePaperComponent from "../DraggablePaperComponent/DraggablePaperComponent";
import { CustomButton, CustomTextfieldWithTouched } from "..";
import { IAlertDialogWithTextConfirmation } from "./AlertDialogWithTextConfirmation.props";

const AlertDialogWithTextConfirmation = ({
	showAlertDialog,
	setShowAlertDialog,
	submitHandler,
	closeHandler,
	description,
	title,
	inputLabel = "",
	isDisabled = false,
	textForConfirm,
}: IAlertDialogWithTextConfirmation): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста
	const [value, setValue] = useState("");
	const [error, setError] = useState(false);

	// закрыть диалоговое окно
	const closeAlertDialog = (): void => {
		setValue("");
		setError(false);
		setShowAlertDialog && setShowAlertDialog(false);
	};

	// обработчик нажатия клавиши
	const keyDownHandler = (e: React.KeyboardEvent<HTMLDivElement>): void => {
		if (e.code === "Enter") {
			e.preventDefault();
			handleSubmit();
		}
	};

	const handleSubmit = (): void => {
		if (!textForConfirm) {
			setError(true);
			return;
		}

		const normalizedText = textForConfirm.replace(/\s+/g, " ").trim();
		const normalizedValue = value.replace(/\s+/g, " ").trim();

		if (textForConfirm !== null && normalizedText === normalizedValue) {
			submitHandler();
			closeHandler ? closeHandler() : closeAlertDialog();
			setValue("");
			setError(false);
		} else {
			setError(true);
		}
	};

	return (
		<Dialog
			open={showAlertDialog}
			onClose={isDisabled ? undefined : closeHandler || closeAlertDialog}
			aria-labelledby="title"
			aria-describedby="alert-dialog-description"
			onKeyDown={isDisabled ? undefined : keyDownHandler}
			PaperComponent={DraggablePaperComponent}
			slotProps={{
				backdrop: {
					sx: { backgroundColor: "rgba(0, 0, 0, 0.15)" },
				},
			}}
		>
			<DialogTitle id="title" color={colorRed} sx={{ fontSize: 16, cursor: "move" }}>
				{translate(title)}
			</DialogTitle>
			<DialogContent sx={{ paddingBottom: 2, display: "flex", flexDirection: "column", gap: "16px" }}>
				<DialogContentText id="alert-dialog-description" sx={{ fontSize: 13 }}>
					{translate(description)}
				</DialogContentText>
				<CustomTextfieldWithTouched
					autoFocus
					value={value}
					onChange={(e) => {
						setValue(e.target.value);
					}}
					label={translate(inputLabel)}
					error={error}
					// запрещаем вставку
					// onPaste={(e) => e.preventDefault()}
					// запрещаем drag&drop текста
					onDrop={(e) => e.preventDefault()}
					// запрещаем контекстное меню
					onContextMenu={(e) => e.preventDefault()}
					// запрещаем перетаскивание текста мышкой
					inputProps={{
						onCopy: (e) => e.preventDefault(),
						onCut: (e) => e.preventDefault(),
						onDrag: (e) => e.preventDefault(),
					}}
				/>
			</DialogContent>
			<DialogActions sx={{ paddingTop: 0 }}>
				<CustomButton variant="text" onClick={closeHandler || closeAlertDialog} disabled={isDisabled}>
					{translate("button_close")}
				</CustomButton>
				<CustomButton variant="text" color="error" onClick={handleSubmit} disabled={isDisabled}>
					{translate("button_confirm")}
				</CustomButton>
			</DialogActions>
		</Dialog>
	);
};

export default AlertDialogWithTextConfirmation;
